import { useRouter } from '@alltrails/core';
import type SharedStaticMapSize from '@alltrails/types/StaticMapSize';
import getStaticMapUrl from '@alltrails/core/utils/getStaticMapUrl';
import usePublicBaseUrl from '@alltrails/context/hooks/usePublicBaseUrl';
import { useCallback } from 'react';
// eslint-disable-next-line @alltrails/custom/client-navigation
import { useParams } from 'next/navigation';
import { apiKey } from '../constants/apiKey';

const staticMapScale: Record<SharedStaticMapSize, number> = {
  '1280x582': 2,
  '512x217': 1,
  '160x160': 2,
  '200x200': 2,
  '295x240': 2,
  '320x320': 2,
  '327x218': 2,
  '342x424': 2,
  '368x182': 2,
  '368x372': 2
};

export type StaticMapSize = SharedStaticMapSize | '1280x480' | '295x240';

type Args = {
  id: string | number;
  size: StaticMapSize;
  type: 'trail' | 'map';
  isLocalized?: boolean;
  scale?: number;
  style?: 'satellite';
};

const types = {
  trail: 'trails',
  map: 'maps'
} as const;

function useLocale() {
  const { locale: localePageRouter } = useRouter() || {};
  const { locale: localeAppRouter } = useParams();

  // One of these should be the correct value for locale.
  const locale = localePageRouter || localeAppRouter || '';

  return locale === 'en' ? '' : locale;
}

export function useStaticMapUrl() {
  const locale = useLocale();
  const publicBaseUrl = usePublicBaseUrl();

  return useCallback(
    ({ id, isLocalized, size, scale, style, type }: Args) => {
      return getStaticMapUrl({
        apiKey,
        baseUrl: publicBaseUrl,
        id,
        locale: isLocalized ? (locale as string) : undefined,
        scale: Boolean(scale) ? scale : staticMapScale[size],
        size,
        style,
        type: types[type]
      });
    },
    [publicBaseUrl, locale]
  );
}
